import { TraceAttributeTypes } from "@/components/ColumnDefinitions";
import { monolithMoment } from "@/utils/date-format";
import { styled, Pill } from "@monolith-forensics/monolith-ui";
import { TraceIndicator } from "@/Features/TraceIndicators";

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.background.default};
  border: 1px solid ${({ theme }) => theme.palette.input.border};

  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;

const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const DetailValue = styled.div`
  white-space: pre-wrap;
  max-height: 150px;
  overflow-y: auto;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
  width: fit-content;
`;

const SubTitle = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.secondary};
  width: fit-content;
`;

const StyledTimestamp = styled(SubTitle)`
  font-size: 12px;
`;

const StyledDescription = styled(SubTitle)`
  margin-top: 10px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

const TraceAttributesList = styled.div`
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 10px;
`;

const StyledAttributeType = styled.span`
  font-weight: 550;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

const StyledAttributeValue = styled.span``;

export const TraceIndicatorItem: React.FC<{
  data: TraceIndicator;
  onClick?: (data: TraceIndicator) => void;
}> = ({ data, onClick }) => {
  data?.trace_attributes?.sort((a, b) => {
    if (b.type.toUpperCase() > a.type.toUpperCase()) return -1;
    if (b.type.toUpperCase() < a.type.toUpperCase()) return 1;
    return 0;
  });

  return (
    <StyledContainer onClick={() => onClick?.(data)}>
      <Title>{data.name}</Title>
      <StyledTimestamp>
        {monolithMoment({
          timestamp: data.created_on,
          includeTime: true,
          includeZone: true,
        })}
      </StyledTimestamp>
      <StyledDescription>
        <DetailItem>
          <DetailValue>{data.description}</DetailValue>
        </DetailItem>
      </StyledDescription>
      <TraceAttributesList>
        {data?.trace_attributes?.map((ta) => (
          <Pill size="xs" key={ta.uuid} showRemoveIcon={false}>
            <StyledAttributeType>
              {
                TraceAttributeTypes.find((type) => type.value === ta.type)
                  ?.label
              }
            </StyledAttributeType>
            <span> : </span>
            <StyledAttributeValue>{ta.value}</StyledAttributeValue>
          </Pill>
        ))}
      </TraceAttributesList>
    </StyledContainer>
  );
};
